import React from 'react';
import { Animation } from '../../assets/global/globalStyles';
import { fetchOrderItems } from '../../store/orderItems';
import { useNavigate } from 'react-router-dom';
import { Container, Link } from './styles';
import OrderProcess from '../../components/OrderProcess';
import vermapa from '../../assets/vermapa.svg';
import useFetch from '../../hooks/useFetch';
import useQuery from '../../hooks/useQuery';
import Table from '../../components/Table';

function OrderStatus() {
  const document = useQuery().get('document');
  const warehouseId = useQuery().get('warehouseId');
  const orderStatus = useQuery().get('orderStatus');
  const licensePlate = useQuery().get('licensePlate');
  const navigate = useNavigate();

  const { data: orderItems } = useFetch(
    fetchOrderItems({
      url: `/deliveryorder/delivery-orders-items?id=${document}&warehouseId=${warehouseId}`,
      method: 'GET',
    }),
    'orderItems',
  );

  const seeOrderMap = (document) => {
    navigate(`/dashboard/map?document=${document}`);
  };

  return (
    <Animation>
      <Container>
        <OrderProcess status={orderStatus} />
        <Link
          disabled={orderStatus !== 'CCC' || licensePlate === null}
          cursor={
            orderStatus !== 'CCC' || licensePlate === null
              ? 'not-allowed'
              : 'pointer'
          }
          onClick={() =>
            (orderStatus === 'CCC' || licensePlate === null) &&
            seeOrderMap(document)
          }
          title={
            orderStatus !== 'CCC' || licensePlate === null
              ? 'Desabilitado'
              : null
          }
          typeName="warning"
        >
          <img src={vermapa} alt="Botão para ver no mapa." />
          Ver no mapa
        </Link>
      </Container>
      <Table
        data={orderItems}
        title={`Remessa: ${document}`}
        keyStorage="ordersItems_filter"
        columns={['material', 'description', 'quantity', 'unit']}
        columnNames={['Material', 'Descrição', 'Quantidade', 'Unidade']}
      />
    </Animation>
  );
}

export default OrderStatus;
